'use strict'

import TransferItem from './transferitem.coffee'

class FileItem extends TransferItem
  _selectItem: ->
    # Check if the item was already selected
    if @isSelected
      return false

    # Set selected flag
    @isSelected = true
    return true

  _deselectItem: ->
    # Check if the item was already selected
    if !@isSelected
      return false

    # Set selected flag
    delete @isSelected
    return true

  constructor: (id, name, @size, @type, @lastModifiedDate) ->
    # Call base
    super id, name

  selectItem: ->
    # Select the item
    if @_selectItem()
      # Update the folder count
      if @folder
        @folder._updateSelectionCount 1, @size

    # Allow chaining
    this

  deselectItem: ->
    # Deselect the item
    if @_deselectItem()
      # Update the folder count
      if @folder
        @folder._updateSelectionCount -1, -@size

    # Allow chaining
    this

  updatePendingStatus: (isPending) ->
    if !!@isPending != isPending
      # Update the pending flag
      if isPending
        @isPending = true
      else
        delete @isPending

      # Update the pending status of all parent folders
      if @folder
        factor = if isPending then 1 else -1
        @folder._updatePendingCount factor, @size * factor

    # Allow chaining
    this

  getSelectionStatus: ->
    if @isSelected then 'ALL' else 'NONE'

  getTotalFileCount: -> 1
  getTotalFileSize: -> @size
  getSelectedFileCount: -> if @isSelected then 1 else 0
  getSelectedFileSize: -> if @isSelected then @size else 0
  getPendingFileCount: -> if @isPending then 1 else 0
  getPendingFileSize: -> if @isPending then @size else 0

  getFriendlyFileType: ->
    if !@_cachedType
      if @type
        if @type.match /^image\/(gif|jpeg|png|svg\+xml)$/
          @_cachedType = 'image'
        else if @type.match /^image\//
          @_cachedType = 'image-no-thumbnail'
        else if (
          @type.match(
            /(^application\/(pdf|msword|vnd\.openxmlformats\-officedocument\.wordprocessingml\.(document|template))|^text\/)/
          )
        )
          @_cachedType = 'document'
        else if @type.match /^audio\//
          @_cachedType = 'audio'
        else if @type.match /^video\//
          @_cachedType = 'video'
        else if (
          @type.match(
            /^(application\/(x-bzip2|x-bsh|x-bzip|x-gzip|x-compressed|x-zip-compressed|zip|x-zip)|multipart\/(x-gzip|x-zip))/
          )
        )
          @_cachedType = 'zip'
        else
          @_cachedType = 'file'
      else
        @_cachedType = 'file'
    @_cachedType

export default FileItem
